import React, { useEffect, useState } from "react";
// import sendRequest from "../Components/AI_Logic";
import {BiArrowBack} from "react-icons/bi"
import "../styles.css";
import {useAuthContext} from '../hooks/useAuthContext';
import { useContentGeneration } from "../hooks/useContentGeneration";
import {useSubscription} from "../hooks/useSubscription";
import { Link } from "react-router-dom";
import { useContentsContext } from "../hooks/useContentsContext";
import ImageDetails from "../Components/ImageDetails";
import dayjs from 'dayjs';
import { jwtDecode } from "jwt-decode";
import Cookies from "js-cookie";
import {Rings} from "react-loader-spinner";
import { useNavigate } from "react-router-dom";
import {Helmet} from "react-helmet";

import { useLogout } from "../hooks/useLogout";
function ImageGeneration() {

  const [topic, setTopic] = useState(null);
  // const [imageData, apiResponse] = useState("");
  const [isDisabled, disableButton] = useState(false);
  // const[subsData,setData] = useState();
  const [show, controlLoader] = useState(false);
  const {logout} = useLogout()
const[error,setError] = useState();
  // const[Image,SetImage] = useState();
const {user,dispatch} = useAuthContext()
const {generateImage, fetchImages,} = useContentGeneration()
const { dispatchcontent,contents } = useContentsContext()
const{subsInfo} = useSubscription()

  function getTopic(event) {
    setTopic(event.target.value);
    
  }

const navigate = useNavigate()

//generate image

  async function sendTopic() {
   
    if (topic !== null && topic !== "") {

      disableButton(true);
      controlLoader(true);
      const data = {prompt:topic}
      const content = await generateImage(data);
   
      controlLoader(false);
      if(content.status === 400){
      
        const json = await content.json()
     
        setError(json.error)
       disableButton(false);
    }else{
   
      // const json = await content.json()

      // apiResponse(json.image);
      // //save generated content history

      // SetImage(`data:image/jpeg;base64, ${json.image}`);
     // saveImages(content.image)
      fetchImage()
       disableButton(false);
     
      }
    }

  }



  // save images data
// const saveImages = async(file) =>{
//  const imageUrl = await saveGeneratedImage(file);
//  dispatch({ type: 'CREATE_CONTENTS', payload: imageUrl })
// }


//fetch image for specific user
const fetchImage = async()=>{
  const dataImages = await fetchImages();

  dispatchcontent({ type: 'FETCH_CONTENTS', payload: dataImages })

}
  
// const handleSubs = async() =>{
//   const data = await getSubs()
  
//   setData(data)
// }




useEffect(() => {
  const users = Cookies.get('token')
  if(!users ){
    logout()
  }
try{

  const User = jwtDecode(users)
  const checkToken = async() =>{
    const isExpired = dayjs.unix(User.exp).diff(dayjs())< 1;
  
  if(!isExpired){
   fetchImage()
    // handleSubs()
  }else{
    const response = await fetch(`${process.env.REACT_APP_API_URL || "http://localhost:4000"}/api/user/refresh-token`, {
      method: 'GET',
      headers: {'Content-Type':'application/json',

  }
  , credentials:'include'
  })
 
if(response.status === 200){
   const json = await response.json()
   dispatch({ type: 'LOGIN', payload: json.token })
   navigate("/")
}else{
  logout()
}
  }

}
  


checkToken()
}catch(e){

  if(e.message.includes("Invalid token specified")){
    logout()
  }

}
// eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

// fetchImage()
 //handleSubs()
if(user){
  return (


    <div  className="min-h-screen lg:w-3/4 md:w-3/4 sm:w-3/4 w-2/3 mt-4 mx-auto ">
      <Helmet>
                <meta charSet="utf-8" />
                <title>AI Images - Content Flash AI</title>
               <meta name="description" content="Content Flash AI is an AI based content generator. Generate blogs, emails,etc in seconds."/>
            </Helmet>
            <Link to="/"><BiArrowBack className="text-gray-600 hover:text-black dark:text-white hover:cursor-pointer mb-2"  size={25}/></Link>
       <div className="rounded p-4 shadow-xl border-1 ">
      <h1 className="py-3 text-left font-Rajdhani font-medium text-3xl dark:text-white bg-gradient-to-r from-black from 1% via-red-500  to-orange-600 to-100% inline-block text-transparent bg-clip-text">Image Generation Flash</h1>
      <p className="font-Rajdhani font-medium text-xl dark:text-white">Generate Text to Images in seconds!</p>
      <div className="form-row">

        <div className="col">
          <label className="font-medium font-Rajdhani py-2">What Image do you want to generate?</label>
          <textarea className="dark:bg-[#2c2f44] dark:text-[#99a0ac] border font-normals rounded shadow-sm w-full font-Rajdhani px-3 text-gray-900 outline-none px-3 py-1 focus:outline-none" required type="text" onChange={getTopic} />
        </div>

        <div className="col">
        { subsInfo && 

subsInfo.status === "inactive" 

?subsInfo.details.images >= subsInfo.details.totalimages  ?
<div>
<p className="font-Rajdhani text-red-600 dark:text-red-400 mt-3">Upgrade to premium to use advanced model for image generation or wait for a month to reset monthly credit.</p>

        <button type="submit" className="btn dark:bg-[#818998] dark:text-white dark:bg-none dark:rounded-2xl  dark:hover:bg-[#818998] dark:hover:text-white text-white  bg-gradient-to-r from-orange-700 to-orange-600   mt-2"   >Generate  
                                    </button>
                                    </div>
         :  <button type="submit" className="btn dark:bg-[#818998] dark:text-white dark:bg-none dark:rounded-2xl  dark:hover:bg-[#818998] dark:hover:text-white text-white  bg-gradient-to-r from-orange-700 to-orange-600   mt-2" disabled={isDisabled} onClick={sendTopic} >Generate  
         </button>:  <button type="submit" className="btn dark:bg-[#818998] dark:text-white dark:bg-none dark:rounded-2xl  dark:hover:bg-[#818998] dark:hover:text-white text-white  bg-gradient-to-r from-orange-700 to-orange-600   mt-2" disabled={isDisabled}  onClick={sendTopic} >Generate  
                                    </button>}
        </div>
        </div>
      </div>
    

  
<div className=" grid sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-3 pt-4 ">
  {error ? <p>{error}</p> :
<Rings visible={show}  color="#dd412b" />
 }




{contents && contents.map((image) =>(

<ImageDetails key={image.name} content={image}/>
          
            ))}

          </div>
</div>
  );

}else{
  return navigate("/")
}
}


export default ImageGeneration;